import Configuration from "../shared/configuration";
import EndPointEntity from "../shared/endpointentity";
import API from "../shared/API";
import Common from "./common";

// Separate from attendanceservice.js on purpose — that one is FingerScanService,
// the retired biometric module on its own FINGERPRINT_URL. This is the delivery
// agents' selfie+geo attendance and shares nothing with it.
export default class AgentAttendanceService {
  constructor() {
    this.config = new Configuration();
    this.endpoint = new EndPointEntity();
    this.common = new Common();
  }

  async getForReview(fromDate, toDate, storeID, onlyFlagged, isRetry) {
    const api = new API({ url: this.config.ITEM_STORE_URL });
    api.createEntity({ name: this.endpoint.GET_AGENT_ATTENDANCE_REVIEW });
    let rows = [];
    let payload = {
      fromDate: fromDate,
      toDate: toDate,
      storeID: storeID,
      onlyFlagged: onlyFlagged,
    };
    await api.endpoints[this.endpoint.GET_AGENT_ATTENDANCE_REVIEW]
      .getAllPost(payload)
      .then((response) => {
        rows = response.data;
      })
      .catch((err) => {
        rows = this.common.handleError(err);
      });

    // Refresh ONCE and retry ONCE. Recursing on a persistent 401 spins forever
    // and the screen just shows a spinner, which is worse than an honest error.
    if (rows && rows.statusCode === 401 && !isRetry) {
      try {
        const response = await this.common.refreshToken();
        this.common.setToken(response);
        rows = await this.getForReview(fromDate, toDate, storeID, onlyFlagged, true);
      } catch (e) {
        rows = { statusCode: 401, message: "Session expired - please log in again." };
      }
    }
    return rows;
  }

  async getMonthly(year, month, storeID, isRetry) {
    const api = new API({ url: this.config.ITEM_STORE_URL });
    api.createEntity({ name: this.endpoint.GET_AGENT_ATTENDANCE_MONTHLY });
    let rows = [];
    let payload = { year: year, month: month, storeID: storeID };
    await api.endpoints[this.endpoint.GET_AGENT_ATTENDANCE_MONTHLY]
      .getAllPost(payload)
      .then((response) => {
        rows = response.data;
      })
      .catch((err) => {
        rows = this.common.handleError(err);
      });
    if (rows && rows.statusCode === 401 && !isRetry) {
      try {
        const response = await this.common.refreshToken();
        this.common.setToken(response);
        rows = await this.getMonthly(year, month, storeID, true);
      } catch (e) {
        rows = { statusCode: 401, message: "Session expired - please log in again." };
      }
    }
    return rows;
  }

  // The image is fetched through the API, never a static path, so it carries the
  // bearer token like any other call. Returns an object URL the <img> can use.
  photoUrl(attendanceID) {
    // ITEM_STORE_URL ends at ".../api/Store" with no trailing slash, so the "/" here is REQUIRED —
    // without it the URL is ".../api/StoreAgentAttendancePhoto/{id}" which matches no route (404).
    return (
      this.config.ITEM_STORE_URL +
      "/" +
      this.endpoint.GET_AGENT_ATTENDANCE_PHOTO +
      "/" +
      attendanceID
    );
  }
}
